/** Lo que devuelve la API del registro de cumplimiento ante entes (CUMP-1). */

export type Ambito = "NACIONAL" | "ESTADAL" | "MUNICIPAL"
export type Periodicidad =
  | "MENSUAL"
  | "TRIMESTRAL"
  | "SEMESTRAL"
  | "ANUAL"
  | "POR_VIGENCIA"
  | "UNICA"
export type Semaforo = "VENCIDA" | "POR_VENCER" | "VIGENTE" | "SIN_REGISTRO" | "CUMPLIDA"

export type Ente = {
  id: number
  codigo: string
  nombre: string
  ambito: Ambito
  sitio_web: string | null
  notas: string | null
  activo: boolean
}

export type Obligacion = {
  id: number
  ente_id: number
  codigo: string
  nombre: string
  descripcion: string | null
  periodicidad: Periodicidad
  dia_limite: number | null
  base_legal: string | null
  responsable_cargo_id: number | null
  activa: boolean
}

export type Registro = {
  id: number
  obligacion_id: number
  periodo: string
  fecha: string
  numero: string | null
  vence: string | null
  observacion: string | null
  soporte_nombre: string | null
  tiene_soporte: boolean
  creado_en: string
  anulado_en: string | null
  motivo_anulacion: string | null
}

export type FilaTablero = {
  obligacion: Obligacion
  ente: Ente
  estado: Semaforo
  vence: string | null
  ultimo: Registro | null
  responsable: string | null
}

export type Tablero = { resumen: Record<Semaforo, number>; filas: FilaTablero[] }

export const SEMAFORO: Record<
  Semaforo,
  { etiqueta: string; tono: "peligro" | "aviso" | "exito" | "neutro" | "info" }
> = {
  VENCIDA: { etiqueta: "Vencida", tono: "peligro" },
  POR_VENCER: { etiqueta: "Por vencer", tono: "aviso" },
  VIGENTE: { etiqueta: "Vigente", tono: "exito" },
  CUMPLIDA: { etiqueta: "Cumplida", tono: "info" },
  SIN_REGISTRO: { etiqueta: "Sin registro", tono: "neutro" },
}

/** El orden de las tarjetas y del filtro: lo urgente primero. */
export const ORDEN_SEMAFORO: Semaforo[] = [
  "VENCIDA",
  "POR_VENCER",
  "VIGENTE",
  "CUMPLIDA",
  "SIN_REGISTRO",
]

export const PERIODICIDADES: { valor: Periodicidad; etiqueta: string }[] = [
  { valor: "MENSUAL", etiqueta: "Mensual" },
  { valor: "TRIMESTRAL", etiqueta: "Trimestral" },
  { valor: "SEMESTRAL", etiqueta: "Semestral" },
  { valor: "ANUAL", etiqueta: "Anual" },
  { valor: "POR_VIGENCIA", etiqueta: "Por vigencia (solvencia, licencia)" },
  { valor: "UNICA", etiqueta: "Única (inscripción)" },
]

export const etiquetaPeriodicidad = (p: Periodicidad) =>
  PERIODICIDADES.find((x) => x.valor === p)?.etiqueta ?? p

/** «2026-10-18» → «18/10/2026», sin pasar por `Date` (que lo correría por la zona). */
export const fechaCorta = (iso: string | null) => {
  if (!iso) return "—"
  const [a, m, d] = iso.slice(0, 10).split("-")
  return `${d}/${m}/${a}`
}

/** Hoy en el navegador, como `AAAA-MM-DD`. */
export const hoyIso = () => {
  const h = new Date()
  const dos = (n: number) => String(n).padStart(2, "0")
  return `${h.getFullYear()}-${dos(h.getMonth() + 1)}-${dos(h.getDate())}`
}
